import { List, Record } from "immutable";

export const VOCABULARY_SPEC_TYPE = "vocabulary";

export type VocabularySpecType = {
  courseId: string | null;
  wordIds: List<string>;
};

type VocabularySpecJS = {
  courseId: string;
  wordIds: string[];
};

const defaultVocabularySpec: VocabularySpecType = {
  courseId: null,
  wordIds: List()
};

export default class VocabularySpec extends Record(defaultVocabularySpec) {}

export function fromJS(values: VocabularySpecJS): VocabularySpec {
  return new VocabularySpec({
    ...values,
    wordIds: List(values.wordIds)
  });
}
